import { css } from '@/styled-system/css';

export const comboboxInputStyles = css.raw({
  'color': 'text.neutral',
  '_placeholder': {
    color: 'Combobox.Input.text.placeholder',
  },
  'textStyle': 'body',
  'flexGrow': 1,
  'width': 0,
  'minWidth': 0,
  'transition': 'background-color calc(infinity * 1s) step-end',
  '&:autofill': {
    WebkitTextFillColor: 'text.neutral',
    color: 'text.neutral',
    boxShadow: {
      base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), inset 0 0 0 1000px transparent',
    },
  },
});
